import * as React from 'react';

import {Button, MenuItem, Nav, Navbar, NavDropdown, NavItem} from "react-bootstrap";
import {Link} from "react-router-dom";
import {isAuthenticated} from "./App";

interface INavProps {
	loggedIn: boolean;
}


export default class CustomNav extends React.Component<INavProps> {
	constructor(props: INavProps) {
		super(props);
		console.log(this.props);
	}


	public async logOut() {
		const rawResponse = await fetch('/api/logout', {
			credentials: 'include',
			headers: {
				'Accept': 'application/json',
				'Content-Type': 'application/json'
			},
			method: 'GET'
		});
		const content = rawResponse;

		const success = !!rawResponse.redirected;
		console.log(content);
		if (content && success === false) {
			console.log('Failed to register');
			isAuthenticated.logged = false;
		} else if (content && success === true) {
			console.log('Registered Successfully');
			isAuthenticated.logged = true;
		}
	}

	public render() {
		return (
			<Navbar>
				<Navbar.Header>
					<Navbar.Brand>
						<Link to="/">Nova Force Data Network</Link>
					</Navbar.Brand>
				</Navbar.Header>
				<Nav>
					<NavItem eventKey={1}>
						<Link to="/">Home</Link>
					</NavItem>
					<NavItem eventKey={2}>
						<Link to="/events">Events</Link>
					</NavItem>
					<NavItem eventKey={3}>
						<Link to="/register">Register</Link>
					</NavItem>
					<NavItem eventKey={4}>
						<Link to="/eddn">EDDN</Link>
					</NavItem>
					<NavItem target='_blank' href={'https://novaforce.com/download/nfdn/'} eventKey={5}>
						<span>Get the EDMC plugin</span>
					</NavItem>
					<NavItem eventKey={6}>
						<Button className={this.props.loggedIn === false ? 'hidden' : ''}  onClick={this.logOut}>Log Out</Button>
					</NavItem>
				</Nav>
			</Navbar>
		)
	}
}



// WEBPACK FOOTER //
// ./src/CustomNav.tsx